import { Breadcrumb, Empty, Input, notification } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AddResourceButton from "./AddResourceButton";
import ResourceCard from "./ResourceCard";
import Grid from "@material-ui/core/Grid";
import { fetchResources } from '../../../redux/resources/actions';

const { Search } = Input;

export const Resources = () => {
    const dispatch = useDispatch();
    const { resources, error } = useSelector((state) => state.resources || {});

    const [resourcesearch, setResourcesearch] = useState([]);
    const [search_Mode, setSearch_Mode] = useState(false);

    useEffect(() => {
        dispatch(fetchResources());
    }, [dispatch]);

    useEffect(() => {
        if (!search_Mode) {
            setResourcesearch(resources);
        }
    }, [resources, search_Mode]);

    useEffect(() => {
        if (error) {
            notification.error({
                message: 'Error',
                description: error,
            });
        }
    }, [error]);

    const resourceSearch_Fun = (value) => {
        if (value.length > 0) {
            setSearch_Mode(true);
            const filteredResources = resources.filter((el) => el.name.includes(value));
            setResourcesearch(filteredResources);
        } else {
            setSearch_Mode(false);
            setResourcesearch([]);
        }
    };

    return (
        <div>
            <Breadcrumb style={{ margin: "16px 0px" }}>
                <Breadcrumb.Item>Resources</Breadcrumb.Item>
                <div style={{ float: "right", marginTop: 20 }}>
                    <Grid container>
                        <Grid item>
                            <Grid container justify="center"></Grid>
                            <Search
                                placeholder="Search"
                                onChange={(e) => {
                                    if (e.target.value.length === 0) setSearch_Mode(false);
                                }}
                                style={{ minWidth: 150, maxWidth: 220 }}
                                enterButton
                                onSearch={resourceSearch_Fun}
                            />
                            <AddResourceButton />
                        </Grid>
                    </Grid>
                </div>
            </Breadcrumb>
            <br />
            <br />
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Grid container justify="center" spacing={2}>
                        {search_Mode ? (
                            resourcesearch.length === 0 ? (
                                <Empty />
                            ) : (
                                resourcesearch.map((item, index) => {
                                    return (
                                        <Grid key={index} item>
                                            <ResourceCard item={item} />
                                        </Grid>
                                    );
                                })
                            )
                        ) : (
                            resources.map((item, index) => {
                                return (
                                    <Grid key={index} item>
                                        <ResourceCard item={item} />
                                    </Grid>
                                );
                            })
                        )}
                    </Grid>
                </Grid>
            </Grid>
        </div>
    );
};

export default Resources;
